// Library Methods
import { useMemo } from "react";

// Components
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

type ProgressBarType = {
  value: number;
  max?: number;
  barColor?: string;
  displayValue?: boolean;
  variant?: string;
};

const ProgressBar = ({
  value,
  max = 100,
  barColor = "#22BE39",
  displayValue = true,
  variant = "normal",
}: ProgressBarType) => {
  const isSmallVariant = useMemo(() => variant === "small", [variant]);
  const progressWidth = useMemo(() => (value / max) * 100, [value, max]);

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="8px"
      minHeight="15px"
      width="100%"
    >
      <Box
        style={{
          width: "100%",
          height: isSmallVariant ? "8px" : "14px",
          backgroundColor: "#5B6D7A20",
          borderRadius: "8px",
        }}
      >
        <Box
          style={{
            height: isSmallVariant ? "8px" : "14px",
            width: `${progressWidth}%`,
            backgroundColor: barColor,
            borderRadius: "8px",
          }}
        />
      </Box>

      {displayValue && (
        <Typography
          minWidth="fit-content"
          textAlign="right"
          fontSize={isSmallVariant ? "10px" : "12px"}
        >
          {value ?? 0}%
        </Typography>
      )}
    </Box>
  );
};

export default ProgressBar;
